import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    NgZone,
    OnDestroy,
    ViewChild,
    inject,
    input,
    output,
    signal,
} from '@angular/core'
import { QuillViewComponent } from 'ngx-quill'

@Component({
    selector: 'app-venue-storefront-booking-policy-step',
    standalone: true,
    imports: [QuillViewComponent],
    templateUrl: './venue-storefront-booking-policy-step.component.html',
    styleUrls: ['./venue-storefront-booking-policy-step.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontBookingPolicyStepComponent implements AfterViewInit, OnDestroy {
    policies = input.required<string[]>()
    accepted = output<void>()

    private readonly ngZone = inject(NgZone)

    @ViewChild('heading', { static: true }) private heading!: ElementRef<HTMLHeadingElement>
    @ViewChild('policyContent', { static: true })
    private policyContent!: ElementRef<HTMLElement>
    @ViewChild('policyActions', { static: true })
    private policyActions!: ElementRef<HTMLElement>

    protected readonly policyRead = signal(true)
    private policyReadStateInitialised = false
    private policyLayoutObserver?: ResizeObserver
    private readonly policyScrollListener = () => {
        this.ngZone.run(() => this.updatePolicyReadState())
    }

    ngAfterViewInit() {
        this.heading.nativeElement.focus({ preventScroll: true })
        document.addEventListener('scroll', this.policyScrollListener, {
            capture: true,
            passive: true,
        })
        this.policyLayoutObserver = new ResizeObserver(() => {
            this.ngZone.run(() => this.updatePolicyReadState())
        })
        this.policyLayoutObserver.observe(this.policyContent.nativeElement)
        this.policyLayoutObserver.observe(this.policyActions.nativeElement)
        this.updatePolicyReadState()
    }

    ngOnDestroy() {
        document.removeEventListener('scroll', this.policyScrollListener, true)
        this.policyLayoutObserver?.disconnect()
    }

    @HostListener('window:resize')
    protected updatePolicyReadState() {
        if (this.policyReadStateInitialised && this.policyRead()) {
            return
        }

        const policyBottom = this.policyContent.nativeElement.getBoundingClientRect().bottom
        const actionsTop = this.policyActions.nativeElement.getBoundingClientRect().top
        const readingBoundary = Math.min(window.innerHeight, actionsTop)
        this.policyReadStateInitialised = true
        this.policyRead.set(policyBottom <= readingBoundary + 1)
    }
}
